import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://postcode.tech/api/v1',
  headers: { Authorization: 'Bearer 3a1615cd-3c40-4acb-864a-bec33be42614' },
});

export default instance;
